import {inject, Injectable} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

type SnackbarType = 'success' | 'warning' | 'error'

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private snackbar = inject(MatSnackBar)

    showNotification(message: string, duration: number = 3000): void {
        this.snackbar.open(message, 'Close', {
            duration,
            horizontalPosition: 'end',
            verticalPosition: 'top',
        })
    }
}
